import { useEffect, useState } from "react";
import "./Hero.scss";
import HeroImg from "./../../../assets/images/Hero.svg";
// import GreenButton from "./../../../components/GreenButton/GreenButton";
import { useLanguage } from "../../../context/LanguageContext";
// import { useAuth } from "../../../context/AuthContext";
// import { useNavigate } from "react-router-dom";

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  // const navigate = useNavigate();
  const { t } = useLanguage(); // Get the translation function
  // const { singleBooking, user } = useAuth();

  useEffect(() => {
    // Trigger animation after component mounts
    setIsVisible(true);
  }, []);

  // const handleNavigate = () => {
  //   // Check if user exists and is a subscriber
  //   if (user && user.isSubscriper) {
  //     navigate("/subscriptions");
  //     return;
  //   }

  //   // Original logic
  //   const element = document.getElementById("subscription");
  //   singleBooking
  //     ? navigate("/services")
  //     : element.scrollIntoView({ behavior: "smooth" });
  // };

  // Determine button text based on conditions
  // const getButtonText = () => {
  //   if (user && user.isSubscriper) {
  //     return t("services");
  //   }
  //   return singleBooking ? t("services") : t("subscribeNow");
  // };

  return (
    <section className="hero">
      <div className="container">
        <div className={`hero__right ${isVisible ? "animate-in" : ""}`}>
          <p className="title">{t("welcome")}</p>
          <div className="subtitle-container">
            <p className="subtitle">{t("welcomeMessage")}</p>
          </div>
          <p>{t("welcomeDesc")}</p>
          {/* <div className="hero__right-actions">
            <GreenButton
              text={getButtonText()}
              size="medium"
              variant="fill"
              onClick={() => handleNavigate()}
            />
          </div> */}
        </div>
        <div className={`hero__left ${isVisible ? "animate-in" : ""}`}>
          <img src={HeroImg} alt="Hero illustration" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
